var _path, _rect, _path2, _rect2, _path3, _rect3, _rect4, _g, _rect5, _rect6, _rect7, _rect8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#4245B1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.7145 111V41.1818H74.8963C80.2599 41.1818 84.7599 42.1136 88.3963 43.9773C92.0554 45.8409 94.8168 48.4545 96.6804 51.8182C98.5668 55.1591 99.5099 59.0568 99.5099 63.5114C99.5099 67.9886 98.5554 71.875 96.6463 75.1705C94.7599 78.4432 91.9759 80.9773 88.294 82.7727C84.6122 84.5455 80.0895 85.4318 74.7259 85.4318H56.0781V74.9318H73.0213C76.1577 74.9318 78.7259 74.5 80.7259 73.6364C82.7259 72.75 84.2031 71.4659 85.1577 69.7841C86.1349 68.0795 86.6236 65.9886 86.6236 63.5114C86.6236 61.0341 86.1349 58.9205 85.1577 57.1705C84.1804 55.3977 82.6918 54.0568 80.6918 53.1477C78.6918 52.2159 76.1122 51.75 72.9531 51.75H61.3622V111H48.7145ZM84.7827 79.3636L102.067 111H87.9531L70.9759 79.3636H84.7827ZM120.118 111H106.618L131.197 41.1818H146.811L171.425 111H157.925L139.277 55.5H138.732L120.118 111ZM120.561 83.625H157.379V93.7841H120.561V83.625ZM180.621 111V41.1818H206.803C212.166 41.1818 216.666 42.1136 220.303 43.9773C223.962 45.8409 226.723 48.4545 228.587 51.8182C230.473 55.1591 231.416 59.0568 231.416 63.5114C231.416 67.9886 230.462 71.875 228.553 75.1705C226.666 78.4432 223.882 80.9773 220.2 82.7727C216.518 84.5455 211.996 85.4318 206.632 85.4318H187.984V74.9318H204.928C208.064 74.9318 210.632 74.5 212.632 73.6364C214.632 72.75 216.109 71.4659 217.064 69.7841C218.041 68.0795 218.53 65.9886 218.53 63.5114C218.53 61.0341 218.041 58.9205 217.064 57.1705C216.087 55.3977 214.598 54.0568 212.598 53.1477C210.598 52.2159 208.018 51.75 204.859 51.75H193.268V111H180.621ZM216.689 79.3636L233.973 111H219.859L202.882 79.3636H216.689Z",
    fill: "#FAFAFD"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 219,
    width: 200,
    height: 66.6667,
    rx: 8,
    fill: "url(#paint0_linear_106_724)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 285.668,
    width: 200,
    height: 66.6667,
    rx: 8,
    fill: "url(#paint1_linear_106_724)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: 352.332,
    width: 200,
    height: 66.6667,
    rx: 8,
    fill: "url(#paint2_linear_106_724)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 209,
    y: 219,
    width: 56.7273,
    height: 200,
    rx: 8,
    fill: "#ECB634"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_724",
    x: 36.7148,
    y: 41.1836,
    width: 201.258,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_724"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_724",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_724",
    x1: 237,
    y1: 219,
    x2: 237,
    y2: 285.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E23A59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812C3C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_724",
    x1: 237,
    y1: 285.668,
    x2: 237,
    y2: 352.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5558DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242568"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_724",
    x1: 237,
    y1: 352.332,
    x2: 237,
    y2: 418.999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30B64F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A5026"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRar);
export default __webpack_public_path__ + "static/media/rar.662240d98eea8639b4288aa2ac5e3be7.svg";
export { ForwardRef as ReactComponent };